import Wrapper from "../../../layout/Wrapper";
import CaseStatementContractDetail from "../../../screens/contractControll/caseIdiomsContract/detail";

import MetaComponent from "../../../components/common/MetaComponent";
import { t } from "i18next";

const metadata = {
	title: t('menu.contractControl.caseIdiomsDetail'),
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CaseStatementContractDetail />
		</Wrapper>
	);
}